<script setup>
import { useI18n } from 'vue-i18n';
import { formatMoney } from '../composables/commissionSheetForm';

defineProps({
  amountCents: { type: Number, default: 0 },
  totals: { type: Object, required: true },
});

const { t } = useI18n();
</script>

<template>
  <tfoot class="border-t-2 border-lais-border bg-lais-bg-soft font-semibold">
    <tr>
      <td class="px-4 py-3">
        {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.TOTAL') }}
      </td>
      <td
        class="px-4 py-3"
        :class="totals.complete ? 'text-emerald-700' : 'text-lais-danger'"
      >
        {{
          t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.PERCENTAGE', {
            value: totals.percentage,
          })
        }}
      </td>
      <td class="px-4 py-3">{{ formatMoney(totals.discountCents) }}</td>
      <td class="px-4 py-3">
        {{ formatMoney(totals.allocatedAmountCents) }}
      </td>
      <td colspan="4" class="px-4 py-3 text-lais-text-muted">
        <div class="grid gap-1">
          <span>
            {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.SHEET_TOTAL') }}
            {{ formatMoney(amountCents) }}
          </span>
          <span>
            {{
              t('REAL_ESTATE_COMMISSION_INSTALLMENT.TABLE.COMPANY_COMMISSION')
            }}
            {{ formatMoney(totals.companyAmountCents) }}
          </span>
        </div>
      </td>
    </tr>
  </tfoot>
</template>
